import PizzaMenu from './PizzaMenu';

export default PizzaMenu;
